import React from "react";
import Button from "../../ui/Button";
import Select, { SelectOptionType } from "../../ui/Select";
import bitsIcon from "../../../../../assets/images/bits_icon.svg";
import BottomBar from "../../BottomBar/BottomBar";
import style from "./CheerBottomBar.module.scss";

interface CheerBottomProps {
  onButtonClick?: () => void;
  isButtonDisabled: boolean;
  selectOptions?: SelectOptionType[];
  onSelectChange: (option: SelectOptionType) => void;
  selectedOption?: SelectOptionType | null;
}

const CheerBottomBar: React.FC<CheerBottomProps> = ({
  onButtonClick,
  isButtonDisabled,
  selectOptions,
  onSelectChange,
  selectedOption,
}) => {
  return (
    <BottomBar>
      <div className={style.cheerBottomBar}>
        <Select
          options={selectOptions}
          menuPlacement="top"
          selectOptions={{ onChange: onSelectChange }}
          value={selectedOption}
        />
        <img src={bitsIcon} className={style.cheerBottomBar__bitsIcon} />
      </div>
      <div>
        <Button onClick={onButtonClick} disabled={isButtonDisabled}>
          Confirm
        </Button>
      </div>
    </BottomBar>
  );
};

export default CheerBottomBar;
